import React from "react";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

function NotFound() {
  return (
    <>
      <Navbar />
      <div style={{ textAlign: "center", padding: "100px" }}>
        <h1>404</h1>
        <p>Oops! Page Not Found</p>
      </div>
      <Footer />
    </>
  );
}

export default NotFound;
